// extracted by mini-css-extract-plugin
export default {"info":"BlockWithInfo_info__Hgo1N","infoWithBackground":"BlockWithInfo_infoWithBackground__J8kXq"};